import { paramsToQuery } from '@/base/MaUtils.js'
import { cacheRequest, makeRequest } from '@/base/MaRequestPooler.js'

export function getVisibilityScore({ trackId, store, countryCode }) {
  return makeRequest(`/app/visibility-score/${store}/country/${countryCode}`, {
    method: 'POST',
    data: { payload: (Array.isArray(trackId) ? trackId : [trackId]).join(',') },
  })
}

export function getVisibilityScoreHistory({ trackId, countries, startDate, endDate }) {
  return cacheRequest(`/app/${trackId}/visibility-score/history?${paramsToQuery({ countries, startDate, endDate })}`)
}

export function getVisibilityScoreGlobal({ trackId }) {
  return makeRequest(`/app/${trackId}/visibility-score/all`)
}

export function getTopVisibleApps({ store, countryCode }, optionalParams) {
  return makeRequest(`/app/visibility-score/${store}/country/${countryCode}/top-apps?${paramsToQuery(optionalParams)}`)
}
